import { StyleEncoder } from './style_encoder';

const style_encoder = () => new StyleEncoder();

const util_types = {
	style_encoder, StyleEncoder
}

export {
	util_types
}